import { ExternalLink } from "../../../../src/components/StyledComponents/Links";
import * as React from 'react';
export default {
  ExternalLink,
  React
};